import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b55c0fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-part-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/choice_vip_icon.png",
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/choice_vip.png?v=1",
  alt: "",
  class: "vip"
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "choice-part rel empty flex-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/empty.png",
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { t } from '@/plugins/i18n'
import { isJA, useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import { queryCustomerShareLinksApi } from '@/apis/goods'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import Drawer from './Drawer.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const show = ref(false)
const drawerRef = ref()
const jump = () => {
  drawerRef.value.open()
}
onMounted(async () => {
  const { data } = await queryCustomerShareLinksApi({
    customerId: store.getters.user.customerId,
    pageNo: 1,
    pageSize: 100
  })
  show.value = data.records?.length > 0
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "choice-part rel",
          onClick: jump
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('一对一专属选品提案')), 1),
          _createVNode(_component_el_button, {
            class: "choice-part-btn",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('查看提案')), 1)
            ]),
            _: 1
          }),
          _hoisted_2,
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)),
    _createVNode(Drawer, {
      ref: (_value, _refs) => {
        _refs['drawerRef'] = _value
        drawerRef.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})